import { SentFixedMessage } from "./SentFixedMessage"

export const SENT_FIXED_MESSAGE_DEFINITIONS: SentFixedMessage[] = [
  { id: 1, value: "応援しています！" },
  { id: 2, value: "ファンです！" },
  { id: 3, value: "イラストが好きです！" },
  { id: 4, value: "物語が好きです！" },
  { id: 5, value: "頑張ってください！" },
  { id: 6, value: "他の作品も期待しています！" },
]
